import { mockAbout } from '@/mocks/homeData';

export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-6">
            {mockAbout.title}
          </h2>
          <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
            {mockAbout.content}
          </p>

          <div className="mt-10 grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
            {[
              { value: '12,000+', label: '漫画作品', icon: 'ri-book-open-line' },
              { value: '800万+', label: '月活读者', icon: 'ri-user-heart-line' },
              { value: '每日更新', label: '同步海外', icon: 'ri-refresh-line' },
              { value: '100%免费', label: '无需付费', icon: 'ri-shield-check-line' },
            ].map((stat, idx) => (
              <div key={idx} className="text-center p-4">
                <div className="w-10 h-10 mx-auto mb-3 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 text-lg">
                  <i className={stat.icon}></i>
                </div>
                <div className="font-heading text-xl md:text-2xl font-bold text-foreground-950">{stat.value}</div>
                <div className="text-xs md:text-sm text-foreground-500 mt-1">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}